import Form from 'components/form';
import Input from 'components/form/TextInput';
import React from 'react';
import { useForm } from './Form';
const { FormItem } = Form;

const EmailField = ({ id, required, inputProps }) => {
  const { getFieldDecorator } = useForm();

  return (
    <FormItem>
      {getFieldDecorator(id, {
        rules: [
          { required, message: 'Required' },
          { type: 'email', message: 'Invalid email address' },
          { max: 100, message: 'Max 100 characters' },
        ],
      })(
        <Input
          fullWidth
          margin="dense"
          inputProps={inputProps}
          placeholder="john@citychurch.com"
          helpText="Please enter a valid email"
        />,
      )}
    </FormItem>
  );
};

export default EmailField;
